import type {
  CharacterizationApiResponse,
  HistorialRiesgosApiResponse,
} from '@/domains/characterization/characterization.entity';
import type { CharacterizationRepository } from '@/domains/characterization/characterization.repository';
import { characterizaitonApiService } from '../http/characterization.api';

/**
 * Implementación del repositorio de datos de caracterización usando API service
 *
 * @remarks
 * Actúa como intermediario entre el dominio y la capa HTTP,
 * validando las respuestas del API antes de devolverlas
 */
class CharacterizationApiRepository implements CharacterizationRepository {
  /**
   * Obtiene los datos de caracterización de un estudiante específico
   *
   * @param codIncorporacionEstudiante - Código único de incorporación del estudiante
   * @throws Error si no se obtienen datos válidos del API
   */
  async getCharacterization(
    codIncorporacionEstudiante: string,
  ): Promise<CharacterizationApiResponse> {
    const characterizationResponse =
      await characterizaitonApiService.getCharacterization(
        codIncorporacionEstudiante,
      );

    if (!characterizationResponse)
      throw new Error('Error al obtener datos de caracterización');

    return characterizationResponse;
  }

  /**
   * Obtiene el historial de riesgos de un estudiante específico
   *
   * @param codIncorporacionEstudiante - Código único de incorporación del estudiante
   * @throws Error si no se obtienen datos válidos del API
   */
  async getHistorialRiesgos(
    codIncorporacionEstudiante: string,
  ): Promise<HistorialRiesgosApiResponse> {
    const historialResponse =
      await characterizaitonApiService.getHistorialRiesgos(
        codIncorporacionEstudiante,
      );

    if (!historialResponse)
      throw new Error('Error al obtener historial de riesgos');

    return historialResponse;
  }
}

export const characterizationApiRepository =
  new CharacterizationApiRepository();
